module.exports = __webpack_public_path__ + "static/media/DSC00562-49_Small.d00ed607.jpg";